$bog_vmap_app_palette $mol_list
	pack_link \
	query? \
	selected? \
	compact false
	dragged? \
	drag_x? 0
	drag_y? 0
	land_classes /$mol_tree2
	rows <= body /$mol_view
	Classes $mol_form_field
		name \Классы пака
		bids / <= total \
		control <= Class_list $mol_list
			rows <= class_rows /
	Ports $mol_form_field
		name <= selected_title \
		bids / <= chain_title \
		control <= Port_list $mol_list
			rows <= port_rows /
	Class_row* $bog_vmap_app_palette_item
		title <= class_title* \
		click? <=> class_click*? null
		current <= class_current* false
		drag_start? <=> class_drag*? null
	Port_row* $bog_vmap_app_palette_port
		sign <= port_sign* \
		body <= port_body* \
		owner <= port_owner* \
		needle <= query?
	Lib $bog_vmap_lib
		pack <= pack_link
		classes <= land_classes
